export const getStatuses = state => state.statuses;
